export default __webpack_public_path__ + "static/media/intangible-benefits-strategy.ba1cd529.svg";